import { HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../../constants/api'
import { EMPTY_LIST } from '../../../../constants/common'
import { RENTAL_PORTAL_MOCK_STATE } from '../../../../constants/rentalPortalMockState'
import { hasRentalPortalMockState } from '../../../../utils/rentalPortalMockState'

import { CONFLICT_STATUS_HELD } from './IntegrationsConflictQueue.constants'

const MOCK_CONFLICT_READ_LATENCY = 320

const MOCK_CONFLICT_ERROR = {
  response: { status: HTTP_STATUS_INTERNAL_SERVER_ERROR },
}

const MOCK_CONFLICT_SOURCE_LABEL = 'RELion ONE'

const MOCK_CONFLICTS = [
  {
    current_edited_at: '2026-07-24T09:12:00+02:00',
    current_edited_by: 'M. Weber',
    current_value: 'Renoviert 2025, Parkettböden, neue Einbauküche.',
    entity: 'Flat',
    field: 'info',
    id: 1,
    incoming_at: '2026-07-28T04:05:00+02:00',
    incoming_value: 'Bezugsfertig ab 01.09.2026, Erstbezug nach Sanierung.',
    record_id: 7012,
    record_label: 'Top 12/3, Musterstraße 4',
    source_label: MOCK_CONFLICT_SOURCE_LABEL,
    status: CONFLICT_STATUS_HELD,
  },
  {
    current_edited_at: '2026-08-02T15:40:00+02:00',
    current_edited_by: 'A. Gruber',
    current_value: 'Stellplatz im Innenhof inkludiert.',
    entity: 'Building',
    field: 'info',
    id: 2,
    incoming_at: '2026-09-17T12:05:00+02:00',
    incoming_value: 'Tiefgaragenplatz gegen Aufpreis verfügbar.',
    record_id: 4004,
    record_label: 'Musterstraße 4',
    source_label: MOCK_CONFLICT_SOURCE_LABEL,
    status: CONFLICT_STATUS_HELD,
  },
]

function withMockLatency() {
  return new Promise(resolve => {
    setTimeout(resolve, MOCK_CONFLICT_READ_LATENCY)
  })
}

function getMockConflictPermissions() {
  return {
    can_resolve: !hasRentalPortalMockState(RENTAL_PORTAL_MOCK_STATE.readOnly),
  }
}

export function getMockImportConflicts() {
  return withMockLatency().then(() => {
    if (hasRentalPortalMockState(RENTAL_PORTAL_MOCK_STATE.error)) {
      return Promise.reject(MOCK_CONFLICT_ERROR)
    }

    return {
      data: {
        items: hasRentalPortalMockState(RENTAL_PORTAL_MOCK_STATE.empty)
          ? EMPTY_LIST
          : MOCK_CONFLICTS.map(conflict => ({
              ...conflict,
              permissions: getMockConflictPermissions(),
            })),
      },
    }
  })
}

export function performMockImportConflictResolve({ conflictId, resolution }) {
  console.debug('[RP mock] POST import/conflicts/resolve/', {
    conflictId,
    resolution,
  })

  return withMockLatency().then(() => {
    if (hasRentalPortalMockState(RENTAL_PORTAL_MOCK_STATE.saveError)) {
      return Promise.reject(MOCK_CONFLICT_ERROR)
    }

    const index = MOCK_CONFLICTS.findIndex(
      conflict => conflict.id === conflictId
    )

    MOCK_CONFLICTS.splice(index, 1)

    return { data: { resolved: true } }
  })
}
